module.exports = __webpack_public_path__ + "static/img/ic_in_bd.37d0951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_in_bd.png
// module id = DDVK
// module chunks = 0